import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-c0eb38c4")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "am-dot" }, null, -1)
const _hoisted_2 = { class: "am-tit" }
const _hoisted_3 = { class: "am-option" }
const _hoisted_4 = { class: "appraise-box" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "appraise-box" }
const _hoisted_7 = ["onClick"]
_popScopeId()

import {
  ref,
  PropType,
  computed,
  toRaw,
  inject,
  watch,
} from "vue";
import BaseModal from "../BaseModal.vue";
import Appraise from "./AppraiseCard.vue";
import { AppraiseConfigType, AppraiseInfo, AppraiseModeEnum } from "./config";
import _ from "lodash";

// 当前选中的模式

export default _defineComponent({
  props: {
  visible: {
    type: Boolean as PropType<boolean>,
    default: () => false,
  },
  appraiseModalInfo: {
    type: Object as PropType<AppraiseInfo>,
    default: () => ({
      msg: "",
    }),
  },
  appraises: {
    type: Array as PropType<AppraiseConfigType[]>,
    default: () => [],
  },
  toBeImproves: {
    type: Array as PropType<AppraiseConfigType[]>,
    default: () => [],
  },
},
  emits: ["update:visible", "onClose", "onSelectAppraise"] as unknown as undefined,
  setup(__props, { emit }: { emit: ({
  (event: "update:visible", newVisible: boolean): void;
  (event: "onClose"): void;
  (emit: "onSelectAppraise", value: AppraiseConfigType): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props
const currentIndex = ref<number>(AppraiseModeEnum.PRAISE);





const appraisesList = computed<AppraiseConfigType[]>(() => props.appraises);
const toBeImproves = computed<AppraiseConfigType[]>(() => props.toBeImproves);

const visibleCompu = computed(() => props.visible);
// 50ms限制
const isLimit = ref(false);

const handleClickAppraise = _.debounce(
  (value: AppraiseConfigType) => {
    if (isLimit.value) {
      setTimeout(() => {
        emit("onSelectAppraise", toRaw(value));
      }, 50);
      isLimit.value = false;
    }
  },
  2000,
  { leading: true, trailing: false }
);

const handleCloseModal = () => {
  emit("update:visible", false);
  emit("onClose");
};

// 模式修改
const handleClickMode = (type: number) => {
  currentIndex.value = type;
};

// 将节点挂载到body
const CIBodyRef: any = inject("CIBodyRef");
const setBodyRef = () => CIBodyRef.value;

watch(
  () => props.visible,
  (newVal) => {
    if (newVal) {
      isLimit.value = true;
    } else {
      isLimit.value = false;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_unref(visibleCompu))
    ? (_openBlock(), _createBlock(BaseModal, {
        key: 0,
        bodyStyle: { width: '45rem' },
        visible: _unref(visibleCompu),
        onOnClose: handleCloseModal,
        getContainer: setBodyRef
      }, {
        title: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("span", _hoisted_2, "对" + _toDisplayString(__props.appraiseModalInfo.msg) + "的评价：", 1),
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("span", {
              class: _normalizeClass(["op-left", { active: currentIndex.value === _unref(AppraiseModeEnum).PRAISE }]),
              onClick: _cache[0] || (_cache[0] = () => handleClickMode(_unref(AppraiseModeEnum).PRAISE))
            }, " 表扬 ", 2),
            _createElementVNode("span", {
              class: _normalizeClass(["op-right", { active: currentIndex.value === _unref(AppraiseModeEnum).TO_BE_IMPROV }]),
              onClick: _cache[1] || (_cache[1] = () => handleClickMode(_unref(AppraiseModeEnum).TO_BE_IMPROV))
            }, " 待改进 ", 2)
          ])
        ]),
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appraisesList), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.title,
                class: "box-item",
                onClick: () => _unref(handleClickAppraise)(item)
              }, [
                _createVNode(Appraise, { appraiseInfo: item }, null, 8, ["appraiseInfo"])
              ], 8, _hoisted_5))
            }), 128))
          ], 512), [
            [_vShow, currentIndex.value == _unref(AppraiseModeEnum).PRAISE]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toBeImproves), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.title,
                class: "box-item",
                onClick: () => _unref(handleClickAppraise)(item)
              }, [
                _createVNode(Appraise, { appraiseInfo: item }, null, 8, ["appraiseInfo"])
              ], 8, _hoisted_7))
            }), 128))
          ], 512), [
            [_vShow, currentIndex.value == _unref(AppraiseModeEnum).TO_BE_IMPROV]
          ])
        ]),
        _: 1
      }, 8, ["visible"]))
    : _createCommentVNode("", true)
}
}

})